import { CentralArizonaActionType } from "./constants";

export const getDefaultState = () => ({
  toggle_about: true, // State for the topics toggle bar (open -> true , close -> false)
  chart: "central_arizona_shortage_impacts",
  entitlements: [],
  priority_entitlements: {}, //entitlements aggregated by priority pool
  entitlement_difference: {}, //contains all percentage difference for every entity
  scenario: "DCP Cuts",
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case CentralArizonaActionType.SET_CHART:
      return setChartSelection(state, action);
    case CentralArizonaActionType.SET_ENTITLEMENTS:
      return updateEntitlements(state, action);
    case CentralArizonaActionType.SET_PRIORITY_ENTITLEMENTS:
      return updatePriorityEntitlements(state, action);
    case CentralArizonaActionType.SET_SCENARIO:
      return setScenarioFilter(state, action);
    case CentralArizonaActionType.TOGGLE_ABOUT:
      return toggleAbout(state, action);
    case CentralArizonaActionType.SET_ENTITLEMENT_DIFFERENCE:
      return setEntitlementDifference(state, action);
    default:
      return state;
  }
};

const setEntitlementDifference = (state, { entitlement_difference }) => {
  return {
    ...state,
    entitlement_difference,
  };
};

const toggleAbout = (state) => {
  return {
    ...state,
    toggle_about: !state.toggle_about,
  };
};

const updateEntitlements = (state, { entitlements }) => {
  return {
    ...state,
    entitlements,
  };
};

const updatePriorityEntitlements = (state, { priority_entitlements }) => {
  return {
    ...state,
    priority_entitlements,
  };
};

const setChartSelection = (state, { chart }) => {
  return {
    ...state,
    chart,
  };
};

const setScenarioFilter = (state, { scenario }) => {
  return {
    ...state,
    scenario,
  };
};
